import React from 'react';
import { Formik, Form, FormikHelpers } from 'formik';
import * as Yup from 'yup';
import Button from '../AppButton/Button';
import FormInputText from './Inputs/FormInputText';
import { ParentPasswordEnterFormType } from './form-types';
import { GlobalTypes, useGlobalState } from '../../contexts/global';
import { checkParentPassword } from '../../moduls/profile';
import { transformErrors } from '../../services/utils';

const initialValues = {
    parent_password: '',
};

const attributes = {
    parent_password: {
        placeholder: 'Vyplňte..',
        label: 'Rodičovské heslo',
        password: true
    },
};

const EnterParentPasswordForm: React.FC<{callback: (password: string) => void}> = ({ callback }) => {
    const { dispatch } = useGlobalState();
    const onSubmit = async (values: ParentPasswordEnterFormType, { setErrors, resetForm }: FormikHelpers<ParentPasswordEnterFormType>) => {
        return checkParentPassword(values.parent_password)
            .then(() => {
                callback(values.parent_password);
                resetForm();
                dispatch({ type: GlobalTypes.ToggleModal, modal: '' });
            })
            .catch((error) => setErrors(transformErrors(error)));
    };

    const validationSchema = Yup.object().shape({
        // eslint-disable-next-line
        parent_password: Yup.string().min(8, 'Minimální délka je ${min} znaků').required('Povinné pole'),
    });

    return (
        <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={validationSchema}>
            {({ isValid, dirty, isSubmitting }) => (
                <Form>
                    <FormInputText name="parent_password" attributes={attributes.parent_password} />
                    <div className="h-text-center h-mt-1">
                        <Button type="submit" color="primary" disabled={!(isValid && dirty)} loading={isSubmitting}>
                            Odeslat
                        </Button>
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default EnterParentPasswordForm;
